import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import { useNavigate, useP } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { ClientButton } from "@/components/button";
import PhoneNumberTextMask from "../../components/phoneNumberTextMask";
import { updateEditValue } from "@/store/slices/waitlist";
import { getPartySizeOptions,useQuery } from "@/utils";
import { showAlert } from '@/store/slices/feedback'

const useWaitInputsStyles = makeStyles({
  root: {
    margin: "11px 20px",
    height: 336,
    padding: "19px 19px",
  },
  fields: {
    width: "90%",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    height: 210,
    justifyContent: "space-between",
    marginTop: 10,
  },
  field: {
    marginBottom: 20,
  },
  buttonBox: {
    margin: "46px auto",
    width: "max-content",
  },
  button: {
    width: 261,
  },
});

export default ({ disabled }) => {
  const classes = useWaitInputsStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const nextPage = window.location.pathname.replace(/\/[^\/]*$/, "/confirm");
  const newWait = useSelector((state) => state.waitlist.edit.value);
  const merchant = useSelector((state) => state.merchant);
  const {qrCodeId = ""} = useQuery()
  const isQrCodeInUse = merchant?.qrCodeId ? merchant?.qrCodeId?.toString() === qrCodeId : true
  const { phone, partySize, name, note } = newWait;
  const [inputErrors, setInputErrors] = useState({});
  const partySizeOptions = getPartySizeOptions(merchant.tables);
  const onChange = (field) => (ev) => {
    dispatch(
      updateEditValue({
        [field]: ev.target.value,
      })
    );
  };
  const onChangePhone = (ev) => {
    let value = ev.target.value;
    // value = value.replace(/\D/g, "")
    // if (value.length > 10) return;
    // if (value === phone) return;
    dispatch(
      updateEditValue({
        phone: value,
      })
    );
  };
  const onJoin = async () => {
    const inputErrors = {};
    const { partySize, name, phone } = newWait;
    if (!partySize || partySize.length === 0) {
      inputErrors.partySize = "required";
    }
    if (!name || name.length === 0) {
      inputErrors.name = "required";
    }
    if (!phone || phone.length === 0) {
      inputErrors.phone = "required";
    } else {
      const onlyNumbers = phone.replace(/\D/g, "");
      if (onlyNumbers.length < 10) {
        inputErrors.phone = "invalid phone number";
      }
    }
    setInputErrors(inputErrors);
    if (inputErrors.partySize || inputErrors.name || inputErrors.phone) {
      return;
    }
    isQrCodeInUse ? navigate(nextPage)
            : dispatch(showAlert('Sorry, the merchant QR code has expired. Please contact the merchant for updated QR code.'))
  };
  return (
    <Paper className={classes.root}>
      <div className={classes.fields}>
        <TextField
          select
          fullWidth
          size={"small"}
          margin={"none"}
          label="Party Size"
          variant="standard"
          id={"party-size"}
          value={partySize}
          onChange={onChange("partySize")}
          disabled={disabled}
          helperText={inputErrors["partySize"]}
          error={inputErrors["partySize"]}
        >
          {partySizeOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          fullWidth
          size={"small"}
          margin={"none"}
          label="Name"
          variant="standard"
          value={name}
          onChange={onChange("name")}
          disabled={disabled}
          helperText={inputErrors["name"]}
          error={inputErrors["name"]}
        />
        <FormControl
          variant="standard"
          size={"small"}
          margin={"none"}
          disabled={disabled}
          fullWidth
        >
          <InputLabel>Phone Number</InputLabel>
          <Input
            value={phone}
            onChange={onChangePhone}
            inputComponent={PhoneNumberTextMask}
            error={inputErrors["phone"]}
            type="tel"
          />
          <FormHelperText>{inputErrors["phone"]}</FormHelperText>
        </FormControl>
        <TextField
          fullWidth
          size={"small"}
          margin={"none"}
          label="Note"
          variant="standard"
          value={note}
          onChange={onChange("note")}
          disabled={disabled}
        />
      </div>
      <div className={classes.buttonBox}>
        <ClientButton
          className={classes.button}
          variant="contained"
          onClick={onJoin}
          disabled={disabled}
          background="#FFA439"
          textcolor="#fff"
        >
          Join waitlist
        </ClientButton>
      </div>
    </Paper>
  );
};
